export default __webpack_public_path__ + "static/media/dark-grey-left.72d48633.svg";